import { OFFER_AND_DEALS_ERROR, OFFER_AND_DEALS_SUCCESS, SAVE_PAST_ORDERS_REDUCER } from '../../constants';
const initialState = {
    offerAndDeals: {},
    offerAndDealsError: false,
    'Generic Categories': {},
    'Localized Offers & Deals': {},
    'Localized Categories': {},
    stores: [],
    currentStore: {},
    pastOrdersData: {},
};
const orderServReducer = (state = initialState, action) => {
    switch (action.type) {
        case OFFER_AND_DEALS_SUCCESS:
            return {
                ...state,
                offerAndDeals: action.response,
                offerAndDealsError: false,
            };
        case OFFER_AND_DEALS_ERROR:
            return {
                ...state,
                offerAndDealsError: true,
            };
        case SAVE_PAST_ORDERS_REDUCER:
            return {
                ...state,
                pastOrdersData: action.response,
            };
        default:
            return state;
    }
};
export default orderServReducer;
